class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

getSearchResults(searchTerm) {
  let term = searchTerm;
  fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        const error = new Error(`HTTP error! status: ${response.status}`);
        this.close();
        throw error;
      }

      return response.text();
    })
    .then((text) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      // Get the HTML content of the section
      const resultsMarkup = doc.querySelector('#shopify-section-predictive-search').innerHTML;

      // Create a new Document fragment from the resultsMarkup to query it
      const resultsDoc = new DOMParser().parseFromString(resultsMarkup, 'text/html');

      // Check if the `.check-empty` class exists
      if (resultsDoc.querySelector('.check-empty')) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
      } else {
        let ht = `<p class="empty-search-result-p">Your search for "${term}" did not yield any results.</p>`;
        this.predictiveSearchResults.innerHTML = ht;
      }
      this.open();
    })
    .catch((error) => {
      this.close();
      console.error('Error fetching search results:', error);
      throw error;
    });
}


  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
